import { MantineThemeComponent } from '../../types';

const TitleDefaultConfig: MantineThemeComponent = {
	styles: () => ( {
		root: {
			color: 'var(--color-text-primary)'
		}
	} )
};

export default TitleDefaultConfig;
